import { render, staticRenderFns } from "./item-gallery-desktop.vue?vue&type=template&id=3a652406&scoped=true"
import script from "./item-gallery-desktop.vue?vue&type=script&lang=js"
export * from "./item-gallery-desktop.vue?vue&type=script&lang=js"
import style0 from "./item-gallery-desktop.vue?vue&type=style&index=0&id=3a652406&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a652406",
  null
  
)

export default component.exports